import { pipe, Either } from "fp";
import React from "react";

import * as Data from "~/Data";
import { Order } from "~/Order";
import { Time } from "~/Time";
import { WebAPI } from "~/WebAPI";

import * as Status from "./Status";

export * as Status from "./Status";

export type Submission = Time.DateTime & {
  readonly status: Status.Status;
  readonly submitter: Submitter.Submitter;
};

export const resend = ({ status, ...submission }: Submission): Submission => ({
  ...submission,
  status: pipe(
    status,
    Either.mapLeft((failure) => Status.Failure.resend(failure))
  ),
});

export const fromWebAPI = (
  submission: WebAPI.ELD.SubmissionFragment
): Submission => ({
  ...Time.DateTime.fromISOUnsafe(submission.createdAt),
  submitter: Submitter.fromWebAPI(submission),
  status: Status.fromWebAPI(submission),
});

// TODO: Use `Human.User`.
export namespace Submitter {
  export type Submitter = Partial<Data.Reference.Reference> & {
    readonly name: string;
  };

  export type Props = { readonly submitter: Submitter };

  export const { equals, compare } = Order.fromCompare<Submitter>((a, b) =>
    Order.string().compare(a.name, b.name)
  );

  export const Component: React.Fn<Props> = ({ submitter }) => (
    <>{submitter.name}</>
  );

  /**
   * The API carries a name only — there is no submitter id on either stack's
   * row — and elogs submissions carry no submitter at all until SC-559295
   * records one, which is why this can be empty.
   */
  export const fromWebAPI = ({
    submittedByName,
  }: Pick<WebAPI.ELD.SubmissionFragment, "submittedByName">): Submitter => ({
    name: submittedByName ?? "",
  });
}
